import React from 'react';
import { Form, OverlayTrigger, Popover } from 'react-bootstrap';

/**
 * A reusable form control component with built-in validation and Bootstrap popover error display
 *
 * @param {string} name - The field name
 * @param {string} label - The field label
 * @param {boolean} required - Whether the field is required
 * @param {object} validationErrors - Object containing validation errors
 * @param {object} formData - The form data object
 * @param {function} handleChange - The change handler function
 * @param {React.ReactNode} children - Custom form control (for select, textarea, etc.)
 * @param {object} props - Additional props to pass to Form.Control
 */
function ValidatedFormControl({
  name,
  label,
  required = false,
  validationErrors = {},
  formData = {},
  handleChange,
  children,
  ...props
}) {
  const hasError = validationErrors[name];

  const popover = hasError ? (
    <Popover id={`popover-${name}`}>
      <Popover.Header as="h3">Validation Error</Popover.Header>
      <Popover.Body>{validationErrors[name]}</Popover.Body>
    </Popover>
  ) : null;

  const formControl = children || (
    <Form.Control
      {...props}
      name={name}
      value={formData[name] || ''}
      onChange={handleChange}
      isInvalid={!!hasError}
    />
  );

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>
      {hasError ? (
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={popover}>
          {formControl}
        </OverlayTrigger>
      ) : (
        formControl
      )}
    </Form.Group>
  );
}

export default ValidatedFormControl;
